export const Status_Cancelable = "O";
export const Status_Start_Passed = "D";
export const Status_Substitute_Assigned = "R";
export const Status_Not_Cancelable = "N";
export const Status_Not_Cancelable_HiddenCancelButton = "X";